import * as React from "react";
import { Search } from "lucide-react";

import { cn } from "@/shared/lib/utils";

interface InputProps extends React.ComponentProps<"input"> {
  type?: string;
  variant?: "default" | "search";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = "default", ...props }, ref) => {
    const input = (
      <input
        type={type}
        ref={ref}
        data-slot="input"
        className={cn(
          "h-10 w-full rounded-md border border-primary bg-white px-3 py-1.5 text-sm text-primary transition-colors outline-none",
          "placeholder:text-tertiary",
          "focus:border-focus",
          "disabled:cursor-not-allowed disabled:opacity-50",
          variant === "search" && "pl-10",
          className,
        )}
        {...props}
      />
    );

    if (variant === "search") {
      return (
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-tertiary" />
          {input}
        </div>
      );
    }

    return input;
  },
);

Input.displayName = "Input";

export { Input };
